import get from 'lodash/get'
import {createSelector} from 'reselect'

// Getters
export const worldpayExpMonth = (state) => get(state, 'worldpay.expMonth')
export const worldpayExpYear = (state) => get(state, 'worldpay.expYear')
export const worldpayPaypageRegistrationId = (state) => get(state, 'worldpay.paypageRegistrationId')
export const isFetchingWorldpayToken = (state) => get(state, 'worldpay.isPending')

// Computed
export const worldpayExpirationDate = createSelector(
  worldpayExpMonth,
  worldpayExpYear,
  (month, year) => (month && year ? `${month}${year}` : null),
)
